export interface PurchaseOrderLineStatusItem {
  id: string;
  purchaseOrderLineStatus: string;
  user: string;
  processedDate: Date;
}
